import { Shell } from '../components';

const stories = [
  { day: '05', month: 'AUG', title: 'はじめて描いた、ままの顔', tone: 'terracotta' },
  { day: '21', month: 'JUL', title: '紙コップでつくったロケット', tone: 'sage' },
  { day: '03', month: 'JUL', title: '「わんわん！」が言えた声', tone: 'ink' },
];

export function HomePage() {
  return (
    <Shell>
      <main>
        <section className="home-hero">
          <div className="home-copy">
            <p className="eyebrow">LITTLE THINGS, BIG TREASURES</p>
            <h1>
              絵も、声も、
              <br />
              わが家の<span style={{ display: 'inline-block' }}>たからもの。</span>
            </h1>
            <p className="lead">
              おえかき、工作、はじめてのことば。
              <br />
              子どもの作品を飾って、声を集めて、お気に入りの写真をとっておきの表紙に。
            </p>
            <a className="button primary" href="#about">
              うちのこばこについて <span aria-hidden="true">→</span>
            </a>
          </div>
          <div className="issue-stack" aria-label="わが子が主役の表紙イメージ">
            <article className="issue-sheet back">
              <p>FAMILY MAGAZINE</p>
              <h2>
                OUR LITTLE
                <br />
                STORIES
              </h2>
            </article>
            <article className="issue-sheet front">
              <header>
                <b>こども新聞</b>
                <time>2026.08</time>
              </header>
              <div className="paper-photo">
                <span>家族の一枚</span>
              </div>
              <h2>
                小さな一歩、
                <br />
                大きなニュース
              </h2>
              <div className="paper-columns">
                <p>朝のリビングで、はじめて一人で立ちました。</p>
                <p>家族みんなの拍手に、本人もにっこり。</p>
              </div>
            </article>
          </div>
        </section>

        <section className="about-section" id="about">
          <div className="section-heading">
            <p className="eyebrow">THREE WAYS TO KEEP</p>
            <h2>
              つくって、飾って、聴き返す。
              <br />
              宝ものが増えていく。
            </h2>
          </div>
          <ol className="steps">
            <li>
              <span>01</span>
              <h3>こどもミュージアム</h3>
              <p>おえかきも工作も、写真に撮ってお気に入りの額へ。作品のお話も声で残せます。</p>
            </li>
            <li>
              <span>02</span>
              <h3>こえのことば帳</h3>
              <p>「まま」「わんわん」、笑い声も。録音して、今だけのかわいい声を集めよう。</p>
            </li>
            <li>
              <span>03</span>
              <h3>わが子が主役の表紙</h3>
              <p>お気に入りの写真と子どもの名前で、とっておきの雑誌表紙に。画像やPDFで残せます。</p>
            </li>
          </ol>
        </section>

        <section className="story-section">
          <div className="section-heading compact">
            <p className="eyebrow">EVERYDAY HISTORY</p>
            <h2>今日が、いつかの宝ものになる。</h2>
          </div>
          <div className="story-list">
            {stories.map((story) => (
              <article key={story.title} className={`story-card ${story.tone}`}>
                <time>
                  <b>{story.day}</b>
                  <span>{story.month}</span>
                </time>
                <div>
                  <span className="story-line" />
                  <h3>{story.title}</h3>
                  <p>わが家のたからもの</p>
                </div>
              </article>
            ))}
          </div>
        </section>
      </main>
    </Shell>
  );
}
